/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S1_ClosingInputs */

const tr_mesafeli_s1_closing = /** @type {(inputs: Mesafeli_S1_ClosingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundan sonra Emonse® "Sağlayıcı", Abone "Müşteri", her iki taraf birlikte "Taraflar" olarak anılacaktır.`)
};

const en_mesafeli_s1_closing = /** @type {(inputs: Mesafeli_S1_ClosingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hereinafter Emonse® shall be referred to as the "Provider", the Subscriber as the "Customer" and both parties together as the "Parties".`)
};

const de_mesafeli_s1_closing = /** @type {(inputs: Mesafeli_S1_ClosingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachfolgend wird Emonse® als "Anbieter", der Abonnent als "Kunde" und beide Parteien zusammen als "Parteien" bezeichnet.`)
};

const ru_mesafeli_s1_closing = /** @type {(inputs: Mesafeli_S1_ClosingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Далее Emonse® именуется «Поставщик», Абонент именуется «Клиент», а обе стороны вместе именуются «Стороны».`)
};

/**
* | output |
* | --- |
* | "Hereinafter Emonse® shall be referred to as the \"Provider\", the Subscriber as the \"Customer\" and both parties together as the \"Parties\"." |
*
* @param {Mesafeli_S1_ClosingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s1_closing = /** @type {((inputs?: Mesafeli_S1_ClosingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S1_ClosingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s1_closing(inputs)
	if (locale === "de") return de_mesafeli_s1_closing(inputs)
	if (locale === "ru") return ru_mesafeli_s1_closing(inputs)
	return tr_mesafeli_s1_closing(inputs)
});